import type {ISbStoryData} from "storyblok-js-client";
import type {AsyncData} from "nuxt/app";
import {type ReffedParameters, unrefParameters} from "../helpers/storyblok";
import {
	useAsyncDataWithPausing,
	type AsyncDataOptionsWithPausing,
} from "./use-async-data-with-pausing";

import {isRef} from "vue";
import {useRuntimeConfig} from "nuxt/app";
import {useStoryblokApi} from "@storyblok/vue";

// NOTE: Also see `useStoryblokStory` and `useStoryblokStoriesList`

export type StoriesData = {
	stories: ISbStoryData[];
	total: number;
};

export function useStoryblokStories(
	fetchKey: string,
	parameters: ReffedParameters,
	asyncOptions: AsyncDataOptionsWithPausing<StoriesData | null> = {},
): AsyncData<StoriesData | null, unknown> {
	const api = useStoryblokApi();
	const watchValues = Object.values(parameters).filter((value) => isRef(value));

	return useAsyncDataWithPausing<StoriesData | null, unknown>(
		fetchKey,
		async () => {
			const storiesRes = await api.getStories({
				resolve_links: "url",
				...unrefParameters(parameters),
				version:
					useRuntimeConfig().public.storyblokVersion === "published"
						? "published"
						: "draft",
			});

			return {
				total: storiesRes.total,
				stories: storiesRes.data.stories,
			};
		},
		{
			watch: watchValues,
			...asyncOptions,
		},
	);
}
